import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef, type ForwardedRef } from 'react'
import { type TabColor } from '../TabContext/TabContext'
import { colors } from '../tokens/colors.stylex'

const dynamicStyles = stylex.create({
  left: (value: number) => ({ left: value }),
  width: (value: number) => ({ width: value }),
  top: (value: number) => ({ top: value }),
  height: (value: number) => ({ height: value }),
})

const colorVariants = stylex.create({
  primary: {
    backgroundColor: colors.primary600,
  },
  blue: {
    backgroundColor: colors.blue600,
  },
  grey: {
    backgroundColor: colors.grey600,
  },
  red: {
    backgroundColor: colors.red600,
  },
})

const orientationStyles = stylex.create({
  horizontal: {
    transition: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'absolute',
    bottom: 0,
    height: 2,
    width: '100%',
  },
  vertical: {
    transition: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'absolute',
    right: 0,
    width: 2,
  },
})

export interface TabsIndicatorProps extends ComponentPropsWithoutRef<'div'> {
  rootRef?: ForwardedRef<HTMLDivElement>
  rootStyle?: stylex.StyleXStyles
  color?: TabColor
  orientation: 'horizontal' | 'vertical'
  start: number
  size: number
}

export const TabsIndicator = (props: TabsIndicatorProps) => {
  const { rootRef, rootStyle, color, orientation, start, size, ...rest } = props
  return (
    <div
      ref={rootRef}
      {...stylex.props(
        orientationStyles[orientation],
        color && colorVariants[color],
        orientation === 'horizontal' ? dynamicStyles.left(start) : dynamicStyles.top(start),
        orientation === 'horizontal' ? dynamicStyles.width(size) : dynamicStyles.height(size),
        rootStyle,
      )}
      {...rest}
    />
  )
}
